import { alpha, PaletteOptions } from "@mui/material/styles";

// Minimal-UI-kit inspired palette. Primary kept as the NTI/Lattice blue.
export const GREY = {
  0: "#FFFFFF",
  100: "#F9FAFB",
  200: "#F4F6F8",
  300: "#DFE3E8",
  400: "#C4CDD5",
  500: "#919EAB",
  600: "#637381",
  700: "#454F5B",
  800: "#212B36",
  900: "#161C24",
};

export const PRIMARY = {
  lighter: "#D6E4FF",
  light: "#5E92F3",
  main: "#1565C0",
  dark: "#003C8F",
  darker: "#00214D",
  contrastText: "#FFFFFF",
};

const SECONDARY = {
  light: "#8E99F3",
  main: "#5C6BC0",
  dark: "#26418F",
  contrastText: "#FFFFFF",
};

const INFO = { light: "#61F3F3", main: "#00B8D9", dark: "#006C9C", contrastText: "#FFFFFF" };
const SUCCESS = { light: "#77ED8B", main: "#22C55E", dark: "#118D57", contrastText: "#FFFFFF" };
const WARNING = { light: "#FFD666", main: "#FFAB00", dark: "#B76E00", contrastText: GREY[800] };
const ERROR = { light: "#FFAC82", main: "#FF5630", dark: "#B71D18", contrastText: "#FFFFFF" };

export const palette: PaletteOptions = {
  mode: "light",
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  divider: alpha(GREY[500], 0.2),
  text: {
    primary: GREY[800],
    secondary: GREY[600],
    disabled: GREY[500],
  },
  background: {
    paper: "#FFFFFF",
    default: GREY[200],
  },
  action: {
    active: GREY[600],
    hover: alpha(GREY[500], 0.08),
    selected: alpha(GREY[500], 0.16),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha(GREY[500], 0.24),
    focus: alpha(GREY[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};
